module.exports = __webpack_public_path__ + "static/media/android-social-media-svgrepo-com.39848b1f.svg";